import { AuthServices } from '@/features/auth/services';
import { auth } from '@/features/auth/types';

import type { GuardianProfile } from './get-guardian';

/** Body for PATCH /api/v1/guardians/me/onboarding (`UpdateOnboardingRequestDto`). */
export type OnboardingProgressUpdate = auth.UpdateOnboardingRequest;

/**
 * Records the outcome of an onboarding step via PATCH
 * `/api/v1/guardians/me/onboarding`. Returns the refreshed guardian profile
 * (with the updated `onboarding` block).
 */
export async function updateOnboardingProgress(
  data: OnboardingProgressUpdate,
): Promise<GuardianProfile> {
  return await AuthServices.updateOnboardingProgress(data);
}
